import { RESET, SHOW_WIDGET, UPDATE, SHOW_PAGE_TOOLS, HIDE_PAGE_TOOLS, SET_STRINGS, LOADED_PAGE_TOOLS, PRE_SAVE_TRANSLATION, SAVE_TRANSLATION, SEARCH, HIDE_WIDGET, SHOW_ALL_TAGS, SHOW_PAGE_TAGS, NEXT_PAGE, PREVIOUS_PAGE, TOGGLE_UNTRANSLATED } from './actionTypes'

function initialState( preserve = {} ) {
  return Object.assign({},{
    tags: [],
    strings : {},
    preSavedTranslations:{},
    pageToolsLoaded:false,
    pageToolsVisible:false,
    widgetVisible:false,
    query: '',
    untranslated: 0,
    showUntranslated: false,
    show : 'page',
    pageIndex:1,
    tagsPPage : 25
  }, preserve )
}

export default function (state = initialState(), action) {
  
  switch ( action.type ) {
    case UPDATE:
      
      state.tags = action.tags.filter((v, i, a) => a.indexOf(v) === i);;
      state.pageIndex = 1

      break;

    case SET_STRINGS:

      state.strings = action.strings
     
      state.untranslated = 0

      for (const [key, string] of Object.entries(state.strings)) {        
        string.languages.forEach ( ( language ) => {
          if ( language.languageTag === otuApp.appState.languageTag && !language.hasKey ) {
            state.untranslated++
          }
        })
      }
    
      break;

    case PRE_SAVE_TRANSLATION:

        state.preSavedTranslations[action.string + '-' + action.language]=action.value
        state.preSavedTranslations = Object.assign({},state.preSavedTranslations)

      break;

    case LOADED_PAGE_TOOLS: 

      state.pageToolsLoaded=true;
      
      break;

    case HIDE_PAGE_TOOLS:

      state.pageToolsVisible = false

      break;

    case SHOW_PAGE_TOOLS:

      state.pageToolsVisible = true

      break;

    case SHOW_WIDGET:

      state.widgetVisible = true

      break;

    case SHOW_PAGE_TAGS:

      state.pageIndex = 1
      state.show = 'page'

      break;

    case SHOW_ALL_TAGS:

      state.pageIndex = 1
      state.show='all'

      break;

    case TOGGLE_UNTRANSLATED:

     state.showUntranslated = !state.showUntranslated
     break;

    case NEXT_PAGE:

      state.pageIndex++

      break;
    
    case PREVIOUS_PAGE:
      state.pageIndex--

      break;

    case HIDE_WIDGET:

      state.widgetVisible = false

      break;

    case SEARCH:

      state.query = action.query

      break;

    case RESET:
      
      state = initialState()

      break
    
    default:
  
    }
    
    return state
}